import { css } from '@terra/ui-styled-system';
import type { TextDiffLineType } from './textDiffUtils';

export const diffRemovedRowClass = css({
  backgroundColor: 'color-mix(in srgb, var(--colors-red-9) 10%, transparent)',
  _hover: {
    backgroundColor: 'color-mix(in srgb, var(--colors-red-9) 15%, transparent)',
  },
});

export const diffAddedRowClass = css({
  backgroundColor: 'color-mix(in srgb, var(--colors-green-9) 10%, transparent)',
  _hover: {
    backgroundColor:
      'color-mix(in srgb, var(--colors-green-9) 15%, transparent)',
  },
});

export const diffUnchangedRowClass = css({
  _hover: {
    bg: 'bg.subtle',
  },
});

export function getDiffRowClass(type: TextDiffLineType): string {
  switch (type) {
    case 'removed':
      return diffRemovedRowClass;
    case 'added':
      return diffAddedRowClass;
    default:
      return diffUnchangedRowClass;
  }
}

export function getDiffRowTextColor(type: TextDiffLineType): string {
  switch (type) {
    case 'removed':
      return 'fg.error';
    case 'added':
      return 'fg.neutral.success';
    default:
      return 'fg.muted';
  }
}
